import DefaultCell from "application/components/DefaultCell";
import RowAction from "application/components/RowAction";

const agentAttributes = {
  formSize: "md",
  columns: 3,
  enableAddButton: true,
  settingsMode: false,
  enableAddAgentButton: true,
  enableAcdDetails: true,
  modes:[]
};

const agentOperationURLS = {
  agentList: "/agent/list",
  agentCreate: "/agent/create",
  delete:"agent/delete",
};

const getAgentColumns = (onEdit,onDelete) => {
  return [
    {
      Header: "Agent From",
      accessor: "from",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width:6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Agent To",
      accessor: "to",
      displayInList: false,
      allowInForm: true,
      allowFilter: false,
      dataType: "string",
      width:6,
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Agent/User ID",
      accessor: "userName",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header:"Agent/User Name",
      accessor: "description",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Email ID",
      accessor: "emailId",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Phone Number",
      accessor: "contactNo",
      displayInList: true,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    // {
    //   Header: "Description",
    //   accessor: "description",
    //   displayInList: false,
    //   allowInForm: false,
    //   allowFilter: false,
    //   dataType: "string",
    //   Cell: ({ value }) => <DefaultCell value={value} />,
    // },
    {
      Header: "Position",
      accessor: "position",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "Queue",
      accessor: "queue",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
    },
    {
      Header: "",
      accessor: "id",
      displayInList: true,
      allowInForm: false,
      Cell: ({ row, value }) => (
        <RowAction
          row={row}
          value={value}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ),
    },
  ];
};

export { getAgentColumns, agentAttributes, agentOperationURLS };
